// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* REPO PATH: src/front-end/code/app/notify/notify.module.css
   REVERT-NOTE(unified-notify): NEW FILE — delete with app/notify if reverting. */

.notify-module__toastStack__B_3ZD {
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3000;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    pointer-events: none;
    max-width: min(480px, calc(100vw - 24px));
}

.notify-module__toast__j_Yhk {
    pointer-events: auto;
    cursor: pointer;
    background: #333;
    color: #fff;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 0.9em;
    box-shadow: 0 4px 14px rgba(0,0,0,0.25);
    max-width: 100%;
    overflow-wrap: anywhere;
    animation: notify-module__toastIn__A9W40 150ms ease-out;
}

.notify-module__success__UJSEf { background: #1e7e34; }
.notify-module__error__Anime   { background: #b02a37; }
.notify-module__info__WxFon    { background: #333; }

@keyframes notify-module__toastIn__A9W40 {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
}`, "",{"version":3,"sources":["webpack://./code/app/notify/notify.module.css"],"names":[],"mappings":";;AAEA;iFACiF;;AAEjF;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,uBAAuB;IACvB,uDAAiC;AACrC;;AAEA,iCAAW,mBAAmB,EAAE;AAChC,iCAAW,mBAAmB,EAAE;AAChC,iCAAW,gBAAgB,EAAE;;AAE7B;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD","sourcesContent":["\n\n/* REPO PATH: src/front-end/code/app/notify/notify.module.css\n   REVERT-NOTE(unified-notify): NEW FILE — delete with app/notify if reverting. */\n\n.toastStack {\n    position: fixed;\n    bottom: 16px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 3000;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    pointer-events: none;\n    max-width: min(480px, calc(100vw - 24px));\n}\n\n.toast {\n    pointer-events: auto;\n    cursor: pointer;\n    background: #333;\n    color: #fff;\n    border-radius: 6px;\n    padding: 8px 16px;\n    font-size: 0.9em;\n    box-shadow: 0 4px 14px rgba(0,0,0,0.25);\n    max-width: 100%;\n    overflow-wrap: anywhere;\n    animation: toastIn 150ms ease-out;\n}\n\n.success { background: #1e7e34; }\n.error   { background: #b02a37; }\n.info    { background: #333; }\n\n@keyframes toastIn {\n    from { opacity: 0; transform: translateY(8px); }\n    to   { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toastStack": `notify-module__toastStack__B_3ZD`,
	"toast": `notify-module__toast__j_Yhk`,
	"toastIn": `notify-module__toastIn__A9W40`,
	"success": `notify-module__success__UJSEf`,
	"error": `notify-module__error__Anime`,
	"info": `notify-module__info__WxFon`
};
export default ___CSS_LOADER_EXPORT___;
